import React from "react";
import { TrialBalanceResponse } from "../../../common/contracts/accounting-reports";
import { DataTableHeaderCell } from "../../general/DataTable/DataTableHeaderCell";

interface Props {
    data: TrialBalanceResponse;
}

export const TrialBalanceTableHeader: React.FC<Props> = ({ data }) => {
    const { periods } = data;
    return (
        <thead>
            <tr>
                <DataTableHeaderCell isTitle></DataTableHeaderCell>
                {periods.map((period) => (
                    <DataTableHeaderCell key={period.label} colSpan={2}>
                        {period.label}
                    </DataTableHeaderCell>
                ))}
            </tr>
            <tr>
                <DataTableHeaderCell isTitle></DataTableHeaderCell>
                {periods.map(() => (
                    <>
                        <DataTableHeaderCell>Debit</DataTableHeaderCell>
                        <DataTableHeaderCell>Credit</DataTableHeaderCell>
                    </>
                ))}
            </tr>
        </thead>
    );
};
